import { HiArrowRightOnRectangle } from "react-icons/hi2";

export const LogoutIcon = ({ width, height, color, ...props }) => (
  <HiArrowRightOnRectangle
    size={width || height || 22}
    color={color || "currentColor"}
    {...props}
  />
);
